export default "__VITE_ASSET__zgshf8uK__"